import { SelectOptions } from '../../components/form_controls/types'
import { IIDAndLabel, IIDAndName } from '../../models/Entity'

// API returns the string field option as strings array,
// e.g: ['option1','option2']
// output: [{value : 'option1', label : 'option1'},

//          {value : 'option2', label : 'option2'}]
export function mapStringOptions(options: string[]): SelectOptions {
  const newOptions: SelectOptions = []
  options.forEach((option) => {
    newOptions.push({ value: option, label: option })
  })
  return newOptions
}

export function mapIDAndNameOptions(options: IIDAndName[]): SelectOptions {
  const newOptions: SelectOptions = []
  options.forEach((option) => {
    newOptions.push({ value: String(option.id), label: option.name })
  })
  return newOptions
}

export function mapIDAndLabelOptions(options: IIDAndLabel[]): SelectOptions {
  const newOptions: SelectOptions = []
  options.forEach((option) => {
    newOptions.push({ value: String(option.id), label: option.label })
  })
  return newOptions
}
